import RatingEstimatesListStates, { RatingEstimatesListProps } from "./RatingEstimatesList.models";
import './RatingEstimatesList.scss'
import React from "react";
import './RatingEstimatesList.scss';
import BannerImage from '../../../assest/images/card-image/ratingEstimatesListList.png';
import RowField from "../../shared/row-field/RowField"
import { QuotaGroups } from "../../../models/interfaces/exams/rating-estimates/QuotaGroups";
import NotFoundExam from "../exam-not-found/NotFoundExam";

export default class RatingEstimatesList extends React.PureComponent<RatingEstimatesListProps, RatingEstimatesListStates>{


    render(): React.ReactNode {
        return <>
            <div className="dropdown-list rating-estimates-list-area" >
                <div className="row">
                    {this.props.WorkBooks.map((report, key) => {
                        let mantaghe = report.quotaGroup === QuotaGroups.Mantaghe1 ? "1" : report.quotaGroup === QuotaGroups.Mantaghe2 ? "2" : "3";
                        return <div key={key} className="col-12 mb-4">
                            <RowField wordRestrictionLeghnt={23} details={{ title: report.description, subTitle: 'بر اساس کنکور 1400 در منطقه ' + mantaghe, imageSource: BannerImage, showButton: true, buttonText: 'کارنامه' }} actionButton={{ onClick: () => this.props.handleRequest(report.rank, report.quotaGroup) }} />
                        </div>
                    })}
                    {this.props.WorkBooks.length <= 0 ?
                        <div className="col-12">
                            <NotFoundExam title="اطلاعاتی یافت نشد" />
                        </div>
                        : <></>}
                </div>
            </div>
        </>
    }
}